import React, { useMemo } from "react";
import CommentsPanel from "../components/comments/CommentsPanel";
import { createBlogCommentsAdapter } from "../components/comments/adapters";
import { getAuthToken } from "../utils/auth";
import "./BlogThoughts.css";

export default function BlogThoughts({ blogId }) {
  const [token, setToken] = React.useState(() => getAuthToken());

  React.useEffect(() => {
    const handleUpdate = () => setToken(getAuthToken());
    window.addEventListener("userUpdated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("userUpdated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  const adapter = useMemo(() => {
    if (!blogId) {
      return null;
    }
    return createBlogCommentsAdapter(blogId, token);
  }, [blogId, token]);

  if (!blogId || !adapter) {
    return null;
  }

  return (
    <CommentsPanel
      entityType="blog"
      entityId={String(blogId)}
      adapter={adapter}
      canComment={true}
      variant="blog"
    />
  );
}
